
// FancyDressActivity
import React from 'react';
import FieldTrip82025 from 'views/FieldTrip82025';


const FancyDressActivityPage = () => {
  return <FieldTrip82025/>;
};

export default FancyDressActivityPage;